<template>
  <modal-component :no-close="noClose" :back="back">
    <div class="loader" v-if="quiz_loading"></div>
    <div v-else-if="!error" class="mx-auto quiz-container">
      <div class="mb-3 mt-1">
        <h1>Quizz</h1>
        <div class="d-flex justify-content-between align-items-center">
          <p class="mb-0">{{ lesson_title }} | {{ quiz.title }}</p>
          <timer v-on:end="sendResults" v-if="showTimer" force-minutes force-seconds v-model="limit"></timer>
        </div>
      </div>
      <div class="white-card" style="min-height: 300px">
        <div class="loader absolute" v-if="loading"></div>
        <template v-if="(state==='evaluation'||state==='correction') && activeQuestion">
          <div class="d-flex justify-content-between mb-3 align-items-center">
            <div class="mr-auto col-md-8 d-flex align-items-center"
                 v-if="!quiz.limit_questions_time && questions.length">
              <carousel class="quiz-carousel w-100" :navigation-enabled="true"
                        :per-page-custom="[[240,5],[768,10]]" :space-padding="0"
                        :pagination-enabled="false" :navigation-click-target-size="0"
                        :scroll-per-page="false">
                <slide v-for="i in questions.length" :key="i">
                <span
                  class="bg-layer mr-2 cursor-pointer wh40x rounded-10 d-flex align-items-center justify-content-center"
                  @click="activeIndex=i-1"
                  :class="{'bg-green': (activeIndex===i-1)}">
                  {{ i }}
                </span>
                </slide>
              </carousel>
              <!--              <span class="ml-3">sur {{ questions.length }}</span>-->
            </div>
            <div v-if="!isEvaluation">
              <button class="btn btn-green" @click="()=> state='result'">Résultats</button>
            </div>
          </div>
          <div class="line bg-gray"></div>
          <div class="question mx-auto d-flex flex-column align-items-center justify-content-center my-5">
            <h4 class="quiz_title d-flex text-green">
              <span v-if="!quiz.limit_questions_time">-Q{{ activeIndex + 1 }}/{{ questions.length }}-</span>
              <span v-else>Q{{ question_index }}/{{ quiz.questions_count }}-</span>
              <timer class="ml-3" v-on:end="submitQuestion" :key="activeIndex" v-if="quiz.limit_questions_time"
                     force-minutes force-seconds
                     :value="question_date.add(activeQuestion.time||1,'m')"></timer>
            </h4>
            <div class="quiz_text text-center html-content" v-html="activeQuestion.content"></div>
            <div class="line bg-gray"></div>
            <template v-if="activeQuestion.qcm">
              <div class="quiz-propositions mt-2" v-if="activeQuestion.options && activeQuestion.options.length">
                <div v-for="(option, ikey) in activeQuestion.options" :key="ikey"
                     @click="select(option)"
                     :class="{'selected': option.selected}"
                     class="bg-white cursor-pointer d-flex border-1x rounded-5 shadow mt-3 p-2 align-items-start quiz-proposition">
                  <span class="quiz-proposition-position">{{ ikey + 1 }}</span>
                  <div class="flex-grow-1 html-content" v-html="option.content"></div>
                  <template v-if="!isEvaluation">
                 <span class="quiz-proposition-value fa fa-check-circle align-self-center text-green"
                       v-if="option.is_response"></span>
                    <span class="quiz-proposition-value fa fa-times-circle align-self-center text-danger"
                          v-else-if="option.selected"></span>
                  </template>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="mt-2 w-100">
                <input v-if="isEvaluation" type="text" class="form-control" v-model="activeQuestion.response"
                       placeholder="Entrez votre réponse ici">
                <p v-else>
                  Votre réponse :
                  <span
                    :class="activeQuestion.response.trim()===activeQuestion.exact_response?'text-green':'text-danger'">
                    {{ activeQuestion.response }}
                    </span>
                  <br>
                  La réponse : <span class="text-green">{{ activeQuestion.exact_response }}</span>
                </p>
              </div>
            </template>
            <div class="quiz-description text-green mt-5 html-content" v-if="!isEvaluation"
                 v-html="activeQuestion.description">
            </div>
          </div>
          <div class="d-flex justify-content-between">
            <div class="left">
              <button class="btn btn-gray"
                      @click.stop="goPrevious" v-if="!quiz.limit_questions_time && hasPrevious">
                <span class="ti-angle-left fz-14"></span>
                Precedent
              </button>
            </div>

            <div class="right">
              <template v-if="!quiz.limit_questions_time">
                <button class="btn btn-gray text-green" v-if="hasNext"
                        @click.stop="goNext">
                  Suivant
                  <span class="ti-angle-right fz-14"></span>
                </button>
                <button v-else-if="isEvaluation" class="btn btn-green"
                        @click="sendResults">
                  <span class="fa fa-check-circle mr-2"></span>
                  Valider
                </button>
              </template>
              <button v-else class="btn btn-green"
                      @click="submitQuestion">
                <span class="fa fa-check-circle mr-2"></span>
                Valider
              </button>
            </div>
          </div>
        </template>
        <div v-else-if="state==='result' && results" class="text-center p-5">
          <h2 class="text-green" style="font-size: 30px">Votre score</h2>
          <h1 class="text-green my-3" style="font-size: 65px;font-weight: 600">
            {{
              results.points === null ? 'Vos réponses ont été prises en compte' : `${results.points} / ${results.total}`
            }}
          </h1>
          <button v-if="!live && !quiz.limit_questions_time" class="btn btn-lg btn-outline-green"
                  @click="showCorrection">Voir la correction
          </button>
          <router-link v-else class="btn btn-lg btn-outline-green" tag="button" :to="{name:'home'}">Quitter
          </router-link>
        </div>
      </div>
    </div>
    <div v-else class="text-center">
      <p class="text-danger">{{ error }}</p>
    </div>
  </modal-component>
</template>
<script>
import moment from "moment";
import ModalComponent from "../components/LayoutPartials/ModalComponent";
import axios from "axios";
import Timer from "@/components/Conference/Timer";
import {mapGetters} from "vuex";

export default {
  name: 'Quiz',
  components: {
    Timer,
    ModalComponent,
  },
  filters: {
    ago: function (data) {
      return moment(data).fromNow();
    }
  },
  computed: {
    ...mapGetters(['mobile']),
    liveQuiz() {
      return this.$route.name === 'live-quiz'
    },
    showTimer() {
      return this.state === 'evaluation' && this.live
    },
    live() {
      return this.$route.name === 'live-quiz'
    },
    activeQuestion() {
      return this.questions[this.activeIndex]
    },
    hasNext() {
      return this.activeIndex < this.questions.length - 1
    },
    hasPrevious() {
      return this.activeIndex > 0
    },
    isEvaluation() {
      return this.state === 'evaluation'
    }
  },
  data() {
    return {
      loading: false,
      quiz_loading: true,
      // mode : [evaluation, correction, result, error]
      state: 'evaluation',
      lesson_title: null,
      // route de retour du modal
      back: this.$route.name === 'lesson-quiz' ? {
        name: 'lesson',
        params: {slug: this.$route.params.slug}
      } : {name: 'home'},
      noClose: this.$route.name !== 'lesson-quiz',
      quiz: {
        id: null,
        title: null,
        slug: null,
      },
      questions: [],
      activeIndex: 0,
      limit: null,
      results: null,
      error: null,
      question_date: null, // from server
      question_index: null // from server
    }
  },
  methods: {
    moment,
    initQuiz(quiz) {
      if (quiz.questions) this.initializeQuestions(quiz)
      this.quiz = quiz
      if (quiz.limit_questions_time) this.loadQuestion()
    },
    loadQuestion($results) {
      if (this.loading) return
      this.loading = true;
      axios.post(`/quiz/${this.quiz.id}/question`, {response: $results})
        .then(({data}) => {
          if (data.finished) {
            this.results = data
            this.state = 'result'
            return
          }
          this.question_date = moment(data.date)
          this.question_index = data.index
          this.initQuestion(data.question)
          this.questions.push(data.question)
          this.activeIndex = this.questions.length - 1
        })
        .catch((error) => {
          console.error(error)
        }).finally(() => {
        this.loading = false;
      });
    },
    submitQuestion() {
      this.loadQuestion(this.activeQuestion.qcm ? this.activeQuestion.options.filter(o => o.selected).map(o => o.id) : this.activeQuestion.response)
    },
    loadQuiz() {
      this.quiz_loading = true;
      if (this.$route.name === 'lesson-quiz') {
        axios.get(`/lesson/${this.$slugId(this.$route.params.slug)}/quiz`)
          .then(({data}) => {
            this.lesson_title = data.title
            if (data.quiz) this.initQuiz(data.quiz)
          })
          .catch((error) => {
            console.error(error)
          }).finally(() => {
          this.quiz_loading = false;
        });
      }
      if (this.$route.name === 'live-quiz') {
        axios.get(`/quiz/live/${this.$route.params.id}`)
          .then(({data}) => {
            this.lesson_title = data.title
            this.limit = moment(data.date).add(data.duration, 'minute')
            if (data.quiz) this.initQuiz(data.quiz)
          })
          .catch((error) => {
            console.error(error)
            this.error = error.response.data
          }).finally(() => {
          this.quiz_loading = false;
        });
      }
    },
    initializeQuestions({questions, shuffle_questions, shuffle_options}) {
      questions.forEach((q, i) => {
        this.initQuestion(q, shuffle_options)
      })
      this.questions = shuffle_questions ? _.shuffle(questions) : questions
    },
    initQuestion(q, shuffle_options) {
      q.options.forEach(o => o.selected = false)
      q.reponse = ''
      if (shuffle_options) {
        q.options = _.shuffle(q.options)
      }
    },
    select(option) {
      if (!this.isEvaluation) return
      this.$set(option, 'selected', !option.selected)
    },
    goNext() {
      if (this.activeIndex < this.questions.length - 1) this.activeIndex++
    },
    goPrevious() {
      if (this.activeIndex >= 1) this.activeIndex--
    },
    sendResults() {
      if (this.state !== 'evaluation') return
      if (this.loading) return
      if (this.quiz.limit_questions_time) return this.submitQuestion()
      this.state = 'result'
      this.loading = true
      axios.post(`/quiz/${this.quiz.id}/result`, {
        data: _.reduce(this.questions, (result, q) => {
          result[q.id] = q.qcm ? q.options.filter(o => o.selected).map(o => o.id) : q.response
          return result
        }, {})
      })
        .then(({data}) => {
          this.results = data
        })
        .catch(e => {
          console.log(e)
          this.state = 'evaluation'
        })
        .finally(() => this.loading = false)
    },
    showCorrection() {
      this.state = 'correction'
      this.activeIndex = 0
    },
  },

  beforeMount() {
    window.onbeforeunload = unloadListener
    this.loadQuiz();
  },
  beforeDestroy() {
    window.onbeforeunload = null
  }
}

const unloadListener = function (e) {
  let msg = "Voulez vous vraiment quitter l'évaluation ?"
  e.returnValue = msg;     // Gecko, Trident, Chrome 34+
  return msg;
}
</script>

<style lang="scss">
.quiz-container {
  width: 75%;
  @include down(768) {
    width: 95%;
  }
}

.question {
  width: 80%;
  @include down(768) {
    width: 100%;
  }

  .quiz-propositions {
    width: 60%;
    @include down(768) {
      width: 100%;
    }
  }
}

.quiz-proposition {
  border: 1.5px solid transparent;

  &.selected {
    border-color: $green;
  }

  .quiz-proposition-position {
    font-weight: 600;
    line-height: 20px;
    font-size: 20px;
    color: $green;
  }
}
</style>
